// Create a drop down picker where the user can select a host to connect to.
// the hosts are:
/**
 * Dropdown component which allows the user to select a host to connect to.
 * the hosts are:
 *      const BASE_URL_001 = "https://stage001.twentyfour.me/"
        const  BASE_URL_002 = "https://stage002.twentyfour.me/"
        const  BASE_URL_003 = "https://stage003.twentyfour.me/"
        const  BASE_URL_PREPROD = "https://preprod.twentyfour.me/"
        const  BASE_URL_PROD = "https://www.twentyfour.me/"
 */

import { L } from '@fullcalendar/list/internal-common'
import { Box, Grid2, Switch, Typography } from '@mui/material'
import PopupSectionRow from 'components/popup/PopupSectionRow'
import usePersistState from 'hooks/usePersistState'
import React, { useEffect, useState } from 'react'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'

const BASE_URLS = [
  { label: 'Stage 001', value: 'https://stage001.twentyfour.me' },
  { label: 'Stage 002', value: 'https://stage002.twentyfour.me' },
  { label: 'Stage 003', value: 'https://stage003.twentyfour.me' },
  { label: 'Preprod', value: 'https://preprod.twentyfour.me' },
  { label: 'Production', value: 'https://www.twentyfour.me' }
]

const DebugPanel: React.FC = () => {
  const [selectedHost, setSelectedHost] = useState(
    BASE_URLS.find(
      (host) =>
        host.value ===
        (LocalStorage.get(LocalStorageKey.APP_HOST) ??
          process.env.REACT_APP_API_URL)
    )?.value
  )

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedHost(event.target.value)
    // You can add additional logic here to handle the selected host

    LocalStorage.set(LocalStorageKey.APP_HOST, event.target.value)

    window.location.reload()
  }

  useEffect(() => {
    if (!LocalStorage.get(LocalStorageKey.APP_HOST)) {
      LocalStorage.set(LocalStorageKey.APP_HOST, process.env.REACT_APP_API_URL)
    }
  }, [])

  return (
    <Box display={'flex'} flexDirection={'column'}>
      <select value={selectedHost} onChange={handleChange}>
        {BASE_URLS.map((host) => (
          <option key={host.value} value={host.value}>
            {host.label}
          </option>
        ))}
      </select>
    </Box>
  )
}

export default DebugPanel
